import Vue from 'vue';
import Vuex from 'vuex';
import ecotron from './ecotron';
import ecofrost from './ecofrost';
import user from './user';
// import VuexPersistence from 'vuex-persist'

// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage
// })

Vue.use(Vuex);

export default new Vuex.Store({
  // plugins: [vuexLocal.plugin],
  modules: {
    ecotron,
    ecofrost,
    user
  },
  state: {
    error: {
      status: false,
      message: []
    }
  },
  mutations: {
    setError(state, payload) {
      if (payload) {
        state.error.status = true;
        state.error.message.push(payload);
      } else {
        state.error.status = false;
        state.error.message = [];
      }
    }
  }
});
